module.exports = __webpack_public_path__ + "img/MERCEDES-BENZ.b3bd0e9d.svg";